import { render, staticRenderFns } from "./ahead.vue?vue&type=template&id=5678cd9d"
import script from "./ahead.vue?vue&type=script&lang=ts"
export * from "./ahead.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports